export default __webpack_public_path__ + "static/media/spark_17.f938a5cc.png";